<div *ngIf="!hasSelectedLocationGroup">
  <input
    class="input-legacy"
    type="text"
    placeholder="{{ 'LOCATIONS_GROUPS_LEGACY_INPUT.PLACEHOLDER' | translate }}"
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
  />

  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedLocationGroup()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let locationGroup of locationsGroups" [value]="locationGroup.id">
      {{ locationGroup.name }}
    </mat-option>
    <mat-option *ngIf="!locationsGroups.length">
      {{ 'LOCATIONS_GROUPS_LEGACY_INPUT.NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
</div>

<div class="selected-input" *ngIf="hasSelectedLocationGroup">
  <input class="input-legacy" type="text" disabled [value]="selectedLocationGroup.name" />

  <button mat-icon-button class="cancel-button" *ngIf="hasSelectedLocationGroup" (click)="deselectLocationGroup()">
    <mat-icon>cancel</mat-icon>
  </button>
</div>
